module.exports = __webpack_public_path__ + "media/images/clattenburg-82c98978fcd127a12d84e3fcf12e434c.png";